<ng-container *ngIf="type == 'square'">
  <ol class="progress-bar">
    <li *ngFor="let step of props?.steps; index as i" class="grid-col">
      <div class="progress-item" [ngClass]="getClass(i)">
        <button placement="bottom" [ngbPopover]="popContent" triggers="manual" [autoClose]="false" #p="ngbPopover"
          *ngIf="step.complete && step.value !== 'Open'; else nonClickable" class="step-content"
          (click)="openPopFaultType(p)" container="body">
          <ng-container *ngTemplateOutlet="stepContent"></ng-container>
        </button>
      </div>

      <ng-template #nonClickable>
        <div class="step-content">
          <ng-container *ngTemplateOutlet="stepContent"></ng-container>
        </div>
      </ng-template>

      <ng-template #stepContent>
        <span class="step-title">
          {{ step.title }}
        </span>
        <div class="progress-circle"></div>
        <span class="progress-title"> </span>
      </ng-template>

      <ng-template #popContent>
        <div class="popover-menu-container">
          <div *ngIf="!step.edited">
            <label>Discipline :</label> {{popupContent?.disName}} <br>
            <label>Person Advised :</label> {{popupContent?.personName}} <br>
            <label>ETA :</label> {{popupContent && popupContent.eta ? _cmHelper.setDate(popupContent?.eta) : ''}}
            {{popupContent && popupContent.eta ? _cmHelper.setTime(popupContent?.eta) : ''}} <br>
            <span *ngIf="step.value === 'At Site'"><label>Arrived At :</label>
              {{popupContent && popupContent.arrivalSiteDateTime ? _cmHelper.setDate(popupContent.arrivalSiteDateTime) : ''}}
              {{popupContent && popupContent.arrivalSiteDateTime ? _cmHelper.setTime(popupContent.arrivalSiteDateTime) : ''}}<br></span>
            <span *ngIf="step.value === 'Responded'"><label>Advised At :</label>
              {{popupContent && popupContent.advisedDateTime ? _cmHelper.setDate(popupContent.advisedDateTime) : ''}}
              {{popupContent && popupContent.advisedDateTime ? _cmHelper.setTime(popupContent.advisedDateTime) : ''}}<br></span>
            <span *ngIf="step.value === 'Responded'"><label>Accepted At :</label>
              {{popupContent && popupContent.availableDateTime ? _cmHelper.setDate(popupContent.availableDateTime) : ''}}
              {{popupContent && popupContent.availableDateTime ? _cmHelper.setTime(popupContent.availableDateTime) : ''}}<br></span>
            <span *ngIf="step.value === 'Work Started'"><label>Started At :</label>
              {{popupContent && popupContent.teamAllocatedDateTime ? _cmHelper.setDate(popupContent?.teamAllocatedDateTime) : ''}}
              {{popupContent && popupContent.teamAllocatedDateTime ? _cmHelper.setTime(popupContent?.teamAllocatedDateTime) : ''}}<br></span>
            <span *ngIf="step.value === 'Work Started'"><label>Self Rectified :</label> No <br></span>
            <span *ngIf="step.value === 'Closed'"><label>FailureStatus :</label>
              {{completeFaultObject?.status}}
            <br></span>
              <span *ngIf="step.value === 'Closed'"><label>FailureCode :</label> {{completeFaultObject?.faultCode}} <br></span>
            <a style="color: #004561" (click)="onEditPopup(i,popupContent)">Edit</a>

          </div>

          <div *ngIf="step.edited">
            <form [formGroup]="statusForm">
              <label>Discipline :</label> {{popupContent?.disName}} <br>
              <label>Person Advised :</label> {{popupContent?.personName}} <br>
              <label>ETA :</label> {{popupContent && popupContent.eta ? _cmHelper.setDate(popupContent?.eta) : ''}}
              {{popupContent && popupContent.eta ? _cmHelper.setTime(popupContent?.eta) : ''}}<br>
  
              <span *ngIf="step.value === 'Responded'">
                <label>Responded At</label><br>
                <dateControl formControlFieldName="respondedDate"  [defaultHeight]="false" >
                </dateControl>
                <input type="text" class="common-text-box" onfocus="(this.type = 'time')"
                  placeholder="HH : MM" formControlName="respondedTime"/><br><br>
              </span>
              <span *ngIf="step.value === 'At Site'">
                <label>Arrived At</label><br>
                <dateControl formControlFieldName="arrivedDate" [defaultHeight]="false" >
                </dateControl>
                <input type="text" class="common-text-box" onfocus="(this.type = 'time')"
                  placeholder="HH : MM" formControlName="arrivedTime"/><br><br>
              </span>
              <span *ngIf="step.value === 'Work Started'">
                <label>Started At</label><br>
                <dateControl formControlFieldName="startedDate"  [defaultHeight]="false" >
                </dateControl>
                <input type="text" class="common-text-box" onfocus="(this.type = 'time')"
                  placeholder="HH : MM" formControlName="startedTime"/><br><br>
              </span>
              <span *ngIf="step.value === 'Work Ended'">
                <label>Completed At</label><br>
                <dateControl formControlFieldName="endedDate"  [defaultHeight]="false">
                </dateControl>
                <input type="text" class="common-text-box" onfocus="(this.type = 'time')"
                  placeholder="HH : MM" formControlName="endedTime"/><br><br>
              </span>
              <span *ngIf="step.value === 'Closed'">
                <label>Failure Status</label><br>
                <input type="text" class="common-text-box"
                  formControlName="failureStatus"/><br><br>
              </span>
              <span *ngIf="step.value === 'Closed'">
                <label>Failure Code</label><br>
                <input type="text" class="common-text-box"
                  formControlName="failureCode"/><br><br>
              </span>
              <a style="color: #004561" *ngIf="step.value !== 'Closed'" (click)="onSavePopup(i,p)">Save</a>
            </form>
          </div>

        </div>
      </ng-template>
    </li>
  </ol>
</ng-container>

<ng-container *ngIf="type == 'circle'">
  <ol class="progress-bar">
    <li *ngFor="let step of props?.steps; index as i" class="grid-col-circle">
      <div class="progress-item" [ngClass]="getClass(i)">
        <div class="step-content">
          <ng-container *ngTemplateOutlet="stepContent"></ng-container>
        </div>
      </div>

      <ng-template #stepContent>
        <span class="step-title">
          {{ step.title }}
        </span>
        <div class="progress-circle"></div>
        <span class="progress-title"> </span>
      </ng-template>
    </li>
  </ol>
</ng-container>